module.exports = __webpack_public_path__ + "static/media/innerWest.a395eca6.png";